module.exports = __webpack_public_path__ + "0df7ce369d36f9c43512b39a43d32d7e.png";